import React from "react";
import { Link } from "react-router-dom";
import { processSteps } from "../mock";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const img = (p) => `${BACKEND}${p}`;

const AboutSection = () => {
  return (
    <section
      className="relative overflow-hidden py-28 lg:py-44 bg-[var(--espresso-deep)] text-[var(--cream)] vc-grain vc-grain-light"
      data-testid="about-section"
    >
      {/* Oversized ambient italic label */}
      <div className="pointer-events-none absolute -top-10 lg:-top-20 right-[-4%] opacity-[0.07] select-none" aria-hidden="true">
        <span className="font-serif-display italic text-[18rem] lg:text-[26rem] leading-none text-[var(--copper-light)]">
          Studio
        </span>
      </div>

      <div className="relative max-w-[1440px] mx-auto px-6 lg:px-20 z-[2]">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-20 items-center">
          {/* Image column */}
          <div className="lg:col-span-5 vc-fade-up">
            <div className="relative vc-copper-halo">
              <div className="aspect-[4/5] overflow-hidden vc-img-zoom">
                <img
                  src={`${BACKEND}/api/static/products/studio-01.webp`}
                  srcSet={`${img("/api/static/products/studio-01-480.webp")} 480w, ${img("/api/static/products/studio-01.webp")} 1050w`}
                  sizes="(min-width: 1024px) 40vw, 100vw"
                  alt="Studio"
                  loading="lazy"
                  decoding="async"
                  className="w-full h-full object-cover"
                />
              </div>
              <span className="absolute -top-5 -left-5 font-serif-display italic text-[var(--copper-light)] text-5xl leading-none">
                N°02
              </span>
            </div>
          </div>

          {/* Copy */}
          <div className="lg:col-span-7">
            <p className="vc-eyebrow text-[var(--copper-light)] mb-10 vc-fade-up" data-testid="about-eyebrow">
              The Studio
            </p>
            <h2 className="font-serif-display font-light text-4xl md:text-5xl lg:text-6xl leading-[1.1] vc-fade-up vc-stagger-1">
              Design is more than something you see.
              <br />
              It&apos;s something you <em className="italic text-[var(--copper-light)]">feel</em>.
            </h2>
            <p className="mt-10 text-[var(--cream)]/65 leading-[1.9] max-w-xl tracking-wide vc-fade-up vc-stagger-2">
              At Venus 3D Creations, we blend imagination with technology to make pieces that bring warmth, character and art into everyday spaces. Every lamp does more than light a room — it sets a mood and tells a story.
            </p>

            <div className="mt-16 grid grid-cols-2 gap-x-10 gap-y-12">
              {processSteps.map((s, i) => (
                <div key={s.n} className={`vc-fade-up vc-stagger-${(i % 4) + 2}`} data-testid={`process-step-${s.n}`}>
                  <p className="font-serif-display italic text-[var(--copper-light)] text-3xl leading-none">{s.n}</p>
                  <div className="mt-5 w-10 h-px bg-[var(--copper-light)]/60" aria-hidden="true" />
                  <h4 className="font-serif-display font-light text-xl mt-5">{s.title}</h4>
                  <p className="text-sm text-[var(--cream)]/55 mt-3 leading-[1.9]">{s.copy}</p>
                </div>
              ))}
            </div>

            <Link
              to="/about"
              data-testid="about-read-more"
              className="mt-16 inline-block text-[11px] tracking-[0.28em] uppercase text-[var(--cream)]/85 vc-link-underline"
            >
              Read the studio story →
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
